import * as React from "react";

import { Actions as ActionsBase } from "@common/components/actions";
import { trDts } from "@modules/datasheets/utils/i18n";
import { getTestAttributes } from "@common/utils/tests";
import { DATASHEETS_MODULE_NAME } from "@modules/datasheets/constants/common";
import { Header as HeaderBase } from "@common/components/Header";
import { Button } from "@common/components/Button";
import { MessageBox } from "@common/components/MessageBox";

import { DatasheetTabNameManagement } from "./components/tab-name-management";

import { DatasheetEditorHeaderProps } from "./header.types";
import { useController } from "./header.controller";

import "./header.styles.scss";

export const Header: React.FC<DatasheetEditorHeaderProps> = (props) => {
  const {
    buttons,
    actions,
    datasheet,
    messageProps,
    tabManagementMode,
    closeMessage,
    handleTabSubmit,
    closeTabManagement,
  } = useController(props);

  return (
    <div className="DatasheetsEditor__header">
      <MessageBox hideMessageBox={closeMessage} {...messageProps} />
      <HeaderBase
        moduleName={
          <>
            {trDts("Datasheets")}
            <span className="DatasheetsEditor__header__name">: {datasheet.name}</span>
          </>
        }
        className="DatasheetsEditor__header__internal"
        classes={{
          controls: "DatasheetsEditor__header__internal__controls",
        }}
      >
        {buttons.map((x) => (
          <Button
            bsStyle="primary"
            key={x.label}
            className="DatasheetsEditor__header__internal__btn"
            onClick={x.onClick}
            {...getTestAttributes(
              DATASHEETS_MODULE_NAME.editor,
              "header-action",
              "btn",
              x.label.replace(" ", "-").toLowerCase()
            )}
          >
            {x.label}
          </Button>
        ))}
      </HeaderBase>
      <ActionsBase classes={{ item: "DatasheetsEditor__header__item" }} items={actions} />
      {tabManagementMode && (
        <DatasheetTabNameManagement
          mode={tabManagementMode}
          onClose={closeTabManagement}
          onSubmit={handleTabSubmit}
        />
      )}
    </div>
  );
};
